<script>
    import PreviewSection from "./PreviewSection";
    import CourseOverviewSection from "../../components/pagesbuilder/sections/CourseOverviewSection";

    export default {
        name: "PreviewCourseOverviewSection",
        mixins: [
            PreviewSection,
            CourseOverviewSection
        ]
    }
</script>
